import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "d17Input",
        "bankNameInput",
        "bankHolderInput",
        "bankRibInput",
        "methodCheckbox",
        "methodLabel",
        "methodWarning"
    ]

    connect() {
        this.checkRequirements()
    }

    checkRequirements() {
        let isD17Valid = true;
        if (this.hasD17InputTarget) {
            isD17Valid = this.d17InputTarget.value.trim().length > 0;
        }

        let isBankValid = true;
        if (this.hasBankNameInputTarget && this.hasBankHolderInputTarget && this.hasBankRibInputTarget) {
            isBankValid = this.bankNameInputTarget.value.trim().length > 0 &&
                this.bankHolderInputTarget.value.trim().length > 0 &&
                this.bankRibInputTarget.value.trim().length > 0;
        }

        if (this.hasMethodCheckboxTarget) {
            this.methodCheckboxTargets.forEach(checkbox => {
                const isD17 = checkbox.value === "d17";
                const isBank = checkbox.value === "bank_transfer";

                let isValid = true;
                if (isD17) isValid = isD17Valid;
                if (isBank) isValid = isBankValid;

                if (!isValid) {
                    checkbox.checked = false; // Uncheck if requirements not met
                    checkbox.disabled = true;
                } else {
                    checkbox.disabled = false;
                }

                this.updateVisuals(checkbox, isValid);
            });
        }
    }

    updateVisuals(checkbox, isValid) {
        const methodType = checkbox.value;

        if (this.hasMethodLabelTarget) {
            const label = this.methodLabelTargets.find(t => t.dataset.methodType === methodType);
            if (label) {
                if (!isValid) {
                    label.classList.add("opacity-50", "cursor-not-allowed", "bg-gray-50", "border-gray-200");
                    label.classList.remove("hover:border-indigo-200", "border-indigo-600", "bg-indigo-50/50", "bg-white", "cursor-pointer");
                } else {
                    label.classList.remove("opacity-50", "cursor-not-allowed", "bg-gray-50");
                    label.classList.add("cursor-pointer");

                    if (checkbox.checked) {
                        label.classList.add("border-indigo-600", "bg-indigo-50/50");
                        label.classList.remove("border-gray-200", "bg-white", "hover:border-indigo-200");
                    } else {
                        label.classList.remove("border-indigo-600", "bg-indigo-50/50");
                        label.classList.add("border-gray-200", "bg-white", "hover:border-indigo-200");
                    }
                }
            }
        }

        if (this.hasMethodWarningTarget) {
            const warning = this.methodWarningTargets.find(t => t.dataset.methodType === methodType);
            if (warning) {
                if (!isValid) {
                    warning.classList.remove("hidden");
                } else {
                    warning.classList.add("hidden");
                }
            }
        }
    }

    toggleMethod(event) {
        this.checkRequirements(); // Refresh visuals for all
    }
}
